module.exports = __webpack_public_path__ + "img/BAWS_AxeBasic2_1.50b1bf47.png";